import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=351fe837&scoped=true&"
import script from "./todoList.vue?vue&type=script&lang=js&"
export * from "./todoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351fe837",
  null
  
)

export default component.exports